













































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IProducerInfoInput } from '@/modules/Producer/interfaces/producer-form'
import SearchProducer from '@/mixins/search-queries/search-producer'
import { producerTypeValues } from '@/modules/Producer/helpers/producer'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppPhoneInput,
    AppTextSearch
  }
})
export default class ProducerFormInfo extends mixins(SearchProducer) {
  @Prop({ type: Object as () => IProducerInfoInput }) value!: IProducerInfoInput

  producerTypeValues = producerTypeValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
